module.exports = __webpack_public_path__ + "assets/img/bluebg.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bluebg.png
// module id = 694
// module chunks = 0